export default __webpack_public_path__ + "static/media/2023-ins-commission-cor.6545a94b.jpg";